import { usePathname } from "next/navigation";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";

import { getWindow } from "src/utility/window";

export function usePageTransition() {
  const router = useRouter();
  const pathname = usePathname();
  const prevPathRef = useRef(pathname);

  const [pageTransition, setPageTransition] = useState(false);

  useEffect(() => {
    const window = getWindow();

    if (!window) {
      return;
    }

    const handleStart = (url: string) => {
      const nextUrl = new URL(url, window.location.origin);
      const nextPath = nextUrl.pathname;

      if (nextPath !== prevPathRef.current) {
        setPageTransition(true);
      }
    };

    const handleComplete = () => {
      prevPathRef.current = pathname;
      setPageTransition(false);
    };

    router.events.on("routeChangeStart", handleStart);
    router.events.on("routeChangeComplete", handleComplete);
    router.events.on("routeChangeError", handleComplete);

    return () => {
      router.events.off("routeChangeStart", handleStart);
      router.events.off("routeChangeComplete", handleComplete);
      router.events.off("routeChangeError", handleComplete);
    };
  }, [pathname, router.events]);

  return pageTransition;
}
